module.exports = __webpack_public_path__ + "img/bootlegger.ef8215bd.jpg";